import { useCallback } from "react";

export const useDownloadModalCheckboxes = ({
  setData,
  setExpandedAccordionIds,
  itemsData,
}) => {
  const handleUpdateAll = useCallback(
    (checked) => {
      setData((prevData) =>
        prevData.map((item) => {
          const newChecked = item.checkboxContent.length ? checked : false;
          const updatedSublist = item.checkboxContent.map((subItem) => ({
            ...subItem,
            checked: newChecked,
          }));

          return {
            ...item,
            checked: newChecked,
            checkboxContent: updatedSublist,
          };
        }),
      );
    },
    [setData],
  );

  const handleSelectAll = useCallback(() => {
    handleUpdateAll(true);
    setExpandedAccordionIds(itemsData.map((item) => item.id));
  }, [handleUpdateAll, itemsData, setExpandedAccordionIds]);

  const handleClearAll = useCallback(() => {
    handleUpdateAll(false);
    setExpandedAccordionIds(itemsData.map((item) => item.id));
  }, [handleUpdateAll, itemsData, setExpandedAccordionIds]);

  return {
    handleSelectAll,
    handleClearAll,
    handleUpdateAll,
  };
};
